import React from 'react'
import { IconSelectListReadonly } from '../../../../../../shared/icon/icon'

// Who manages a person's name and address in this organization (content's
// read-only `managedBy` on the user-login reads, owner's live SCIM test
// 2026-10-26). { kind: 'scim' | 'sso', connectionID, connectionName,
// displayName } or null. The fields are never editable on
// this page; this says why.

export const LOCK_LINE = 'Change these in your identity provider; EducationXR updates them on the next sync.'

// "EdXR Azure Dev": the sign-in label the organization sees (displayName),
// else the connection's name. The connection's internal staff-only name
// (providerName) is never shown here.
export const connectionLabel = managedBy => {
  if (!managedBy) return ''
  return (managedBy.displayName || '').trim() || (managedBy.connectionName || '').trim()
}

export const isScim = managedBy => !!managedBy && managedBy.kind === 'scim'
export const isManaged = managedBy => !!managedBy && (managedBy.kind === 'scim' || managedBy.kind === 'sso')

// "Provisioned by EdXR Azure Dev" (the identity provider's
// name; "your identity provider" if the connection has none).
export const provisionedText = managedBy => `Provisioned by ${connectionLabel(managedBy) || 'your identity provider'}`

// The page's label: SCIM names the connection; SSO says which one signs
// them in (their names are set when the account is made, never re-synced).
export const managedSentence = managedBy => {
  if (!isManaged(managedBy)) return ''
  return isScim(managedBy)
    ? provisionedText(managedBy)
    : `Signs in with ${connectionLabel(managedBy)}`
}

// The Users list's short form of the same.
export const managedLabel = managedBy => {
  if (!isManaged(managedBy)) return ''
  return isScim(managedBy) ? provisionedText(managedBy) : `Signs in with ${connectionLabel(managedBy)}`
}

// A person's page title: their name, else the address exactly as stored.
export const personTitle = ({ firstName, lastName, email } = {}) => {
  const name = `${firstName || ''} ${lastName || ''}`.trim()
  return name || email || ''
}

export const ManagedNote = ({ managedBy }) => {
  if (!isManaged(managedBy)) return null
  return (
    <p className="sw-hint small mb-3" data-testid="managed-note">
      {isScim(managedBy) && <IconSelectListReadonly className="me-1" />}
      <span>{managedSentence(managedBy)}</span>
    </p>
  )
}

// A lock beside a field's label, for the fields SCIM owns (an SSO sign-in does not re-sync them).
export const FieldLock = ({ managedBy }) => {
  if (!isScim(managedBy)) return null
  return <span className="ms-1 text-body-secondary" role="img" aria-label="Managed by your identity provider" title={LOCK_LINE}><IconSelectListReadonly /></span>
}
